import { render, staticRenderFns } from "./BacklogByLocation.vue?vue&type=template&id=1dc8faa7&scoped=true&"
import script from "./BacklogByLocation.vue?vue&type=script&lang=js&"
export * from "./BacklogByLocation.vue?vue&type=script&lang=js&"
import style0 from "./BacklogByLocation.vue?vue&type=style&index=0&id=1dc8faa7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc8faa7",
  null
  
)

export default component.exports